import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP8NrNew202605: FaireAdPerformancePeriodEntity = {
  token: "perf_p8_nr_new_202605",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-05-01",
  endDate: "2026-05-31",
  impressions: 33708,
  clicks: 635,
  adsSpendDollars: 3750,
  budgetDollars: 6000,
  salesDollars: 18543,
  bestEstimateRoas: 4.94,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.63,
  newCustomersAcquired: 37,
  dataAvailableAtDate: "2026-06-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
